import { render, staticRenderFns } from "./PlaguesVG.vue?vue&type=template&id=81f44578"
import script from "./PlaguesVG.vue?vue&type=script&lang=js"
export * from "./PlaguesVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports